var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export var convertCustomElProps = function (props, customMapping) {
    if (customMapping === void 0) { customMapping = {}; }
    return Object.keys(props)
        .filter(function (key) { return !(props[key] instanceof Function); })
        .reduce(function (acc, key) {
        var _a, _b;
        var prop = props[key];
        var computedKey = customMapping[key] || key;
        if (prop instanceof Object || prop instanceof Array) {
            return __assign(__assign({}, acc), (_a = {}, _a[computedKey] = JSON.stringify(prop), _a));
        }
        return __assign(__assign({}, acc), (_b = {}, _b[computedKey] = prop, _b));
    }, {});
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var useCustomElement = function (props, customMapping, reactRef) {
    if (customMapping === void 0) { customMapping = {}; }
    var ref = reactRef ? reactRef : React.createRef();
    React.useLayoutEffect(function () {
        var current = ref.current;
        var fns;
        if (current) {
            fns = Object.keys(props)
                .filter(function (key) { return props[key] instanceof Function; })
                .map(function (key) { return ({
                key: customMapping[key] || key,
                fn: function (customEvent) {
                    return props[key](customEvent.detail, customEvent);
                },
            }); });
            fns.forEach(function (_a) {
                var key = _a.key, fn = _a.fn;
                return current.addEventListener(key, fn);
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
            if (current) {
                fns.forEach(function (_a) {
                    var key = _a.key, fn = _a.fn;
                    return current.removeEventListener(key, fn);
                });
            }
        };
    }, [customMapping, props, ref]);
    var customElementProps = convertCustomElProps(props, customMapping);
    return [customElementProps, ref];
};
//# sourceMappingURL=use-custom-element.js.map